import useSelector from '@app/hooks/useSelector';

import { getFileFormats, getUnassignedKeysPerPlatformFilename } from '../../../../reducers/downloadData/selectors';
import type { FileFormat, FileFormats, Format } from '../../../../types';
import UnassignedKeysWarning from './UnassignedKeysWarning';

const getFormat = (fileFormat: FileFormat, fileFormats: FileFormats): Format | undefined =>
    fileFormats.flatMap(({ formats }) => formats).find(({ value }) => value === fileFormat);

interface UnassignedKeysWarningContainerProps {
    fileFormat: FileFormat;
    includeAllPlatformKeys: boolean;
}

const UnassignedKeysWarningContainer = ({
    fileFormat,
    includeAllPlatformKeys,
}: UnassignedKeysWarningContainerProps) => {
    const fileFormats = useSelector(getFileFormats);
    const unassignedKeysPerPlatformFilename = useSelector(getUnassignedKeysPerPlatformFilename);

    const format = getFormat(fileFormat, fileFormats);

    const platform = format?.platform ?? '';

    const key = includeAllPlatformKeys ? `all_${platform}` : `limit_${platform}`;

    const unassignedKeys = unassignedKeysPerPlatformFilename?.[key]
        ? Number(unassignedKeysPerPlatformFilename[key])
        : undefined;

    const fallbackFileName = format?.fallbackFilename ?? '';

    if (!unassignedKeys || fallbackFileName === '') {
        return null;
    }

    return <UnassignedKeysWarning unassignedKeys={unassignedKeys} fallbackFileName={fallbackFileName} />;
};

export default UnassignedKeysWarningContainer;
